import { render } from "./practice-linked-practices.html?vue&type=template&id=5fbc98d4&scoped=true&ts=true&external"
import script from "./practice-linked-practices.ts?vue&type=script&lang=ts&external"
export * from "./practice-linked-practices.ts?vue&type=script&lang=ts&external"

import "./practice-linked-practices.scss?vue&type=style&index=0&id=5fbc98d4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbc98d4"]])

export default __exports__